import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BlogHero() {
  const { elementRef } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="relative pt-36 pb-20 overflow-hidden" style={{ background: '#0f0f0f' }}>
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/c9519e5dfc125956816733ee6e13b896.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(15,15,15,0.7), rgba(15,15,15,0.95))' }} />
      <div ref={elementRef} className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center scroll-animate-fade-up">
        <p className="text-xs font-bold tracking-[0.35em] uppercase mb-4" style={{ color: '#B8860B' }}>
          Fitness · Nutrition · Mindset
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight text-white">
          The Legacy <span style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Blog</span>
        </h1>
        <p className="text-base sm:text-lg max-w-2xl mx-auto leading-relaxed" style={{ color: '#aaaaaa' }}>
          Real talk on training, nutrition, and the mindset it takes to build a body — and a life — worth being proud of.
        </p>
        <div className="w-16 h-1 mx-auto rounded-full mt-8" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)' }} />
      </div>
    </section>
  );
}
